import React, { Component } from 'react';
import injectSheet from 'react-jss';
import Countdown from 'react-countdown-now';
import { Link } from 'react-router-dom';

import {
  Card, CardBody,
} from 'reactstrap';

const styles = {
  cardContainer: {
    // marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
  },
  card: {
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },

  btnEndSession: {
    background: '#34A5DA',
    color: '#FFFFFE',
    fontFamily: 'Lato, Arial',
    fontSize: '16px',
    textAlign: 'center',
    float: 'right',
    padding: '0.5rem',
    borderRadius: '0.1rem',
    cursor: 'pointer',
    '& > a': {
      textDecoration: 'none',
      color: '#FFFFFE',
    },
  },
  countDown: {
    fontFamily: 'Lato, Arial',
    fontSize: '1.75rem',
    color: '#34A5DA',
  },
};


class CountDownCard extends Component {
  renderer = ({ hours, minutes, seconds }) => {
    const { classes } = this.props;
    return <span className={classes.countDown}>{hours}:{minutes}:{seconds}</span>;
  };

  render() {
    const { classes, start, to, showBtn } = this.props;
    return (
      <div className={classes.cardContainer}>
        <Card className={classes.card}>
          <CardBody>
            <Countdown
              date={Date.now() + start}
              renderer={this.renderer}
            />

            { showBtn ? (
              <span className={classes.btnEndSession}>
                <Link to={to}>End Session</Link>
              </span>
            ) : '' }
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default injectSheet(styles)(CountDownCard);



// WEBPACK FOOTER //
// ./src/components/CountDownCard.js